import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-custome-detector-update',
  templateUrl: './custome-detector-update.component.html',
  styleUrls: ['./custome-detector-update.component.css']
})
export class CustomeDetectorUpdateComponent implements OnInit {
 
  private paramSubscription: Subscription;

  constructor(public route:ActivatedRoute,private _dataService: DataService) { }
  customeDetectorApplicationList :any  ;
  updatedDescription:string="";
  updatedRisk:string="1";
  updatedBusinessRelevance:string="1";
  updatedTags:string="";
  updatedCategories:string="";
  indexList:number;

  riskCSSNewData: string[] = [
    'tag tbtn-very-low',
    'tag tbtn-low',
    'tag tbtn-medium',
    'tag tbtn-high',
    'tag tbtn-very-high',
  ];
  riskBusinessLevelIcon: string[] = [
    '../assets/images/risk_very_low.svg',
    '../assets/images/risk_low.svg',
    '../assets/images/risk_midum.svg',
    '../assets/images/risk_high.svg',
    '../assets/images/risk_very_high.svg',
  ];
  riskBusinessLevel: string[] = [
    'Very Low',
    'Low',
    'Medium',
    'High',
    'Very High',
  ];

  ngOnInit(): void {
   /* this.paramSubscription = this.route.params.subscribe(el => {
      this.filterCustomeDetectorApplicationList = el.filterCustomeDetectorApplicationList;
    }); */
    this._dataService.sharedParam.subscribe(param=>this.customeDetectorApplicationList=param);
    console.log('.....inside update...........',this.customeDetectorApplicationList);
  }

  getRiskCSSDataNew(appIndex: any) {
    return this.riskCSSNewData[appIndex - 1];

  }

  getRiskLevelIcon(appIndex: any) {
    return this.riskBusinessLevelIcon[appIndex - 1];
  }
 
  getRiskLevel(appIndex: any) {
    return this.riskBusinessLevel[appIndex - 1];
  }

  openUpdateDetails(listindex:number){
    this.indexList=listindex;
    this.openModal('newAppDetails');
  }

  openModal(modalType) {
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'block';
    (document.getElementById(modalType) as HTMLInputElement).style.top = '50px';
  }

  closeModal(modalType) {
    (document.getElementById(modalType) as HTMLInputElement).style.display = 'none';
    //this.isChecked = false;
  }

  updateDetails(){
    this.customeDetectorApplicationList[this.indexList].appDescription=this.updatedDescription;
    this.customeDetectorApplicationList[this.indexList].riskIndex=this.updatedRisk;
    this.customeDetectorApplicationList[this.indexList].productivityIndex=this.updatedBusinessRelevance;
    this.customeDetectorApplicationList[this.indexList].tags=this.updatedTags;
    this.customeDetectorApplicationList[this.indexList].category=this.updatedCategories;
    this.closeModal('newAppDetails');
  }

  onRiskSelected(riskValue:string){
    this.updatedRisk=riskValue;
  }

  onBusniessRelevenceSelected(busniessRelevanceValue:string){
    this.updatedBusinessRelevance=busniessRelevanceValue;
  }

}
